import { z } from "zod";

export const UnderwritingAgentTraceSchema = z.object({
	traceId: z.string(),
	parentTraceId: z.string().nullable(),
	final: z.boolean().optional().default(false),
	intent: z.string().nullable().optional(),
	taskSlug: z.string(),
	submissionId: z.string(),
	message: z.string(),
	timestamp: z.union([z.iso.datetime(), z.date()]),
});

export type UnderwritingAgentTrace = z.infer<typeof UnderwritingAgentTraceSchema>;
